import { render, staticRenderFns } from "./offShelfList.vue?vue&type=template&id=1ac4d114"
import script from "./offShelfList.vue?vue&type=script&lang=js"
export * from "./offShelfList.vue?vue&type=script&lang=js"
import style0 from "./offShelfList.vue?vue&type=style&index=0&id=1ac4d114&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports